import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../constants/config';
import { apiFetchWithTokenRefresh } from '../utils/tokenInterceptor';

export interface Announcement {
  id: number;
  title: string;
  message: string;
  type: 'info' | 'warning' | 'error' | 'success';
  target_audience: string;
  target_user_ids?: number[] | null;
  is_active: boolean;
  starts_at?: string | null;
  ends_at?: string | null;
  call_to_action?: { text: string; url: string } | null;
  image_url?: string | null;
  created_by?: number | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export const useActiveAnnouncements = (options?: { enabled?: boolean }) => {
  return useQuery<Announcement[]>({
    queryKey: ['announcements', 'active'],
    queryFn: async () => {
      const response = await apiFetchWithTokenRefresh(
        `${API_URL}/admin/announcements?active_only=true`,
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (!response.ok) {
        // If unauthorized, return empty array (user not logged in)
        if (response.status === 401 || response.status === 403) {
          return [];
        }
        const errorData = await response
          .json()
          .catch(() => ({ detail: 'Unknown error' }));
        throw new Error(errorData.detail || 'Failed to fetch announcements');
      }

      return response.json();
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: options?.enabled !== false, // Only fetch when enabled is not explicitly false
  });
};
